import React from 'react';
import { Table } from '@tanstack/react-table';
import { ActingQueryData } from '@area-restrita/api-client/model/actingQueryData';

import DataTable from '@/components/DataTable';
import DataTablePagination from '@/components/DataTable/DataTablePagination';
import DataTableViewOptions from '@/components/DataTable/DataTableViewOptions';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

interface IProps {
  table: Table<ActingQueryData>;
  isLoading: boolean;
  onRowClick: (row: ActingQueryData) => void;
}

const BuslineActingView: React.FC<IProps> = ({
  isLoading,
  table,
  onRowClick,
}) => {
  return (
    <div>
      <Card>
        <CardHeader>
          <CardTitle>Execuções de rota</CardTitle>
          <CardDescription></CardDescription>
        </CardHeader>

        <CardContent className="p-0">
          <div className="space-y-4">
            <div className="flex items-center justify-between space-x-4 px-4">
              <DataTableViewOptions table={table} />
            </div>
            <DataTable
              table={table}
              isLoading={isLoading}
              onRowClick={onRowClick}
            />
            <DataTablePagination className="px-4 pb-4" table={table} />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BuslineActingView;
